import { create, type StoreApi, type UseBoundStore } from "zustand";
import { persist } from "zustand/middleware";

interface DesktopUiState {
  /** Desktop レイアウトの History Sidebar (左カラム) の開閉状態 */
  historySidebarOpen: boolean;
  setHistorySidebarOpen: (open: boolean) => void;
  toggleHistorySidebar: () => void;
  /** 全データクリアフローから呼ばれる reset。defaults へ戻す。 */
  resetDesktopUi: () => void;
}

const DEFAULT_DESKTOP_UI: Pick<DesktopUiState, "historySidebarOpen"> = {
  historySidebarOpen: false,
};

export const useDesktopUiStore: UseBoundStore<StoreApi<DesktopUiState>> =
  create<DesktopUiState>()(
    persist(
      (set) => ({
        ...DEFAULT_DESKTOP_UI,
        setHistorySidebarOpen: (open: boolean) =>
          set({ historySidebarOpen: open }),
        toggleHistorySidebar: () =>
          set((s) => ({ historySidebarOpen: !s.historySidebarOpen })),
        resetDesktopUi: () => set({ ...DEFAULT_DESKTOP_UI }),
      }),
      { name: "aimg-desktop-ui" },
    ),
  );
